import * as S from './style.OperationMovementMonitoring';

const OperationMovementMonitoring = () => {
    return (
        <S.Container>

        </S.Container>
    )
}

export default OperationMovementMonitoring;
